import fetchApi from './requests';
import { NotificationDataUrl } from '../Routes/notification.route';
import { NotificationDataType } from '../Types/notification.type';

export const getNotificationData = async (body: {
  clubBranchId: number;
  skip: number;
  take: number;
}): Promise<NotificationDataType[]> => {
  const response = await fetchApi(NotificationDataUrl(), body);
  return response?.ok ? response.data : null;
};
